import { render, staticRenderFns } from "./OrcamentoItemEdit.vue?vue&type=template&id=42b4afa0&scoped=true"
import script from "./OrcamentoItemEdit.vue?vue&type=script&lang=js"
export * from "./OrcamentoItemEdit.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoItemEdit.vue?vue&type=style&index=0&id=42b4afa0&prod&lang=css"
import style1 from "./OrcamentoItemEdit.vue?vue&type=style&index=1&id=42b4afa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b4afa0",
  null
  
)

export default component.exports